import { IGradeHorarioComponentProps } from '@/@types/GradeHorarioSalaAula';
import { AlertMessage } from '@/components/shared/AlertMessage';
import { InputWithLabel } from '@/components/shared/InputWithLabel';
import { Loading } from '@/components/shared/Loading';
import { SelectComponent } from '@/components/shared/SelectComponent';
import { SelectItem } from '@/components/ui/select';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Button } from '@/components/shared/Button';
import { RowTableGradeHorario } from './RowTableGradeHorario';
import { CardHeader } from '@/components/shared/CardHeader';


/**
 * Componente para exibir a grade de horários das salas de aula.
 * @param props As propriedades do componente, incluindo filtros e opções de seleção.
 * @returns O componente de grade de horários.
 */


const GradeHorarioComponent = ({
    ano,
    setAno,
    diaSemanaSelecionado,
    diasSemana,
    disciplinaSelecionada,
    disciplinas,
    docenteSelecionado,
    docentes,
    horarios,
    salaAulaSelecionada,
    salasAula,
    semestre,
    setDiaSemanaSelecionado,
    setDisciplinaSelecionada,
    setDocenteSelecionado,
    setSalaAulaSelecionada,
    setSemestre,
    isLoading
}: IGradeHorarioComponentProps) => {

    const handleClearSelection = (e: React.MouseEvent<HTMLButtonElement>) => {
        // * Limpa todos os filtros de seleção
        e.preventDefault();

        setDisciplinaSelecionada('');
        setDiaSemanaSelecionado('');
        setDocenteSelecionado('');
        setSalaAulaSelecionada('');
    }
    // console.log(disciplinas);
    return (
        <div className='w-full border-[1px] mt-[16px] rounded-[0.25rem]'>
            <CardHeader>
                <form className='w-full'>
                    <div className='flex gap-10'>
                        <InputWithLabel
                            label='Ano Catálogo'
                            placeholder='Digite o Ano Catálogo'
                            type='number'
                            value={ano}
                            min={2010}
                            onChange={({ target }) => setAno(parseInt(target.value))}
                        />
                        <InputWithLabel
                            label='Semestre'
                            placeholder='Digite o Semestre'
                            type='number'
                            value={semestre}
                            min={1}
                            max={2}
                            onChange={({ target }) => setSemestre(parseInt(target.value))}
                        />
                    </div>
                    <div className='md:flex md:w-full md:gap-5'>

                        <SelectComponent value={disciplinaSelecionada} onChange={(value) => setDisciplinaSelecionada(value)} className='flex-1' placeholder='Selecione a disciplina' label='Disciplinas'>
                            {/* select de disciplinas */}
                            {disciplinas.map((subject, index) => {
                                // console.log(subject.COD_DISCI+index)
                                return <SelectItem key={subject.COD_DISCI + index} value={subject.COD_DISCI}>{subject.COD_DISCI} {subject.NOME_DISCI && `/ ${subject.NOME_DISCI}`} ({subject.CTURMA}) </SelectItem>;
                            })}
                        </SelectComponent>

                        <SelectComponent value={docenteSelecionado} onChange={(value) => setDocenteSelecionado(value)} className='flex-1' placeholder='Selecione o docente responsável' label='Docente'>
                            {/* select de docentes */}
                            {docentes.map(docente => {
                                return <SelectItem key={docente.ra} value={docente.ra}>{docente.displayName}</SelectItem>
                            })}
                        </SelectComponent>

                    </div>



                    <div className='md:flex md:w-full md:gap-5'>

                        <SelectComponent value={salaAulaSelecionada} onChange={(value) => setSalaAulaSelecionada(value)} className='flex-1' placeholder='Selecione a sala' label='Sala Aula'>
                            {/* select de salas de aula */}
                            {salasAula.map(classroom => {
                                // return <SelectItem key={classroom._id} value={classroom.sigla}>{classroom.sigla}</SelectItem>
                                return <SelectItem key={classroom._id} value={classroom.sigla || classroom.descricao}>{classroom.sigla || classroom.descricao}</SelectItem>
                            })}
                        </SelectComponent>

                        <SelectComponent className='flex-1' value={diaSemanaSelecionado} placeholder='Selecione o dia da semana' label='Dia Semana' onChange={(value) => setDiaSemanaSelecionado(value)} >
                            {/* select de dias da semana */}
                            {diasSemana.map((weekDay, index) => {
                                return <SelectItem key={index} value={weekDay.value}>{weekDay.name}</SelectItem>
                            })}
                        </SelectComponent>

                    </div>
                    <Button variant='primary' className='mt-3' onClick={handleClearSelection} label='Limpar Seleção'/>
                </form>
            </CardHeader>

            {isLoading ? (
                <Loading color='primary' />
            ) : (
                <>
                    {horarios.length == 0 ? (
                        <AlertMessage message='Não há dados disponíveis para os filtros selecionados. Por favor, verifique os critérios de pesquisa e tente novamente.' />
                    ) : (
                        <>
                            <div className='mt-[16px]'>
                                <Table>
                                    <TableHeader className='text-lg'>
                                        <TableRow>
                                            <TableHead>Dia</TableHead>
                                            <TableHead>Horário</TableHead>
                                            <TableHead>Sala</TableHead>
                                            <TableHead>Sigla</TableHead>
                                            <TableHead>Disciplina</TableHead>
                                            <TableHead>Docente</TableHead>
                                        </TableRow>


                                    </TableHeader>
                                    <TableBody>
                                        {horarios.map(horario => {
                                            return <RowTableGradeHorario horario={horario} />
                                        })}
                                    </TableBody>
                                </Table>
                            </div>
                        </>
                    )}
                </>
            )}


        </div>
    );
}

export { GradeHorarioComponent };